import TravelCare1 from "../assets/img/travel-care-1.svg";
import TravelCare2 from "../assets/img/travel-care-2.svg";
import TravelCare3 from "../assets/img/travel-care-3.svg";
import TravelCare4 from "../assets/img/travel-care-4.svg";
import TravelCare5 from "../assets/img/travel-care-5.svg";
import TravelCare6 from "../assets/img/travel-care-6.svg";

export const travelCareData = [
  {
    icon: TravelCare1,
    label: "Upgrade your fare class",
    info: ["Receive a flexible fare ticket"],
  },
  {
    icon: TravelCare2,
    label: "Feeling ill and can't travel? ",
    info: ["We've got you covered: 100% refund or travel credit"],
  },
  {
    icon: TravelCare3,
    label: "Lost or mishandled baggage?",
    info: ["We'll retrieve it or pay you $1000.00 per bag!"],
  },
  {
    icon: TravelCare4,
    label: "Missed connection, delayed or canceled flight?",
    info: ["We've got you covered: 100% refund or travel credit"],
  },
  {
    icon: TravelCare5,
    label: "Priority access to our VIP concierge desk 24/7",
    info: [
      "· Instant assistance",
      "· Lounge Access advice",
      "· Meet and Greet Service"
    ],
  },
  {
    icon: TravelCare6,
    label: "Extra Benefits",
    info: [
      "· Free seat/meal assignment on code-share & restricted carriers",
      "· Pet Travel Consultancy",
      "· Stopover Paid by Carrier guidance",
    ],
  },
];
